/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: Vlgv2YqSKmv3
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicInputField.module.css"; // plasmic-import: Vlgv2YqSKmv3/css

createPlasmicElementProxy;

export const PlasmicInputField__VariantProps = new Array("status");

export const PlasmicInputField__ArgProps = new Array(
  "placeholder",
  "type",
  "inputId",
  "valueInput"
);

const $$ = {};

function PlasmicInputField__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          type: "text"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textbox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $props.valueInput;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.status
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <input
      data-plasmic-name={"textbox"}
      data-plasmic-override={overrides.textbox}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.input,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.textbox,
        {
          [sty.textboxstatus_error]: hasVariant($state, "status", "error"),
          [sty.textboxstatus_normal]: hasVariant($state, "status", "normal")
        }
      )}
      id={(() => {
        try {
          return $props.inputId;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      name={(() => {
        try {
          return $props.name;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      onChange={async (...eventArgs) => {
        (e => {
          generateStateOnChangeProp($state, ["textbox", "value"])(
            e.target.value
          );
        }).apply(null, eventArgs);
      }}
      placeholder={(() => {
        try {
          return $props.placeholder;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      ref={ref => {
        $refs["textbox"] = ref;
      }}
      required={(() => {
        try {
          return $props.required;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      type={(() => {
        try {
          return $props.type;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return "text";
          }
          throw e;
        }
      })()}
      value={generateStateValueProp($state, ["textbox", "value"]) ?? ""}
    />
  );
}

const PlasmicDescendants = {
  textbox: ["textbox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInputField__ArgProps,
          internalVariantPropNames: PlasmicInputField__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInputField__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "textbox") {
    func.displayName = "PlasmicInputField";
  } else {
    func.displayName = `PlasmicInputField.${nodeName}`;
  }
  return func;
}

export const PlasmicInputField = Object.assign(
  // Top-level PlasmicInputField renders the root element
  makeNodeComponent("textbox"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicInputField
    internalVariantProps: PlasmicInputField__VariantProps,
    internalArgProps: PlasmicInputField__ArgProps
  }
);

export default PlasmicInputField;
/* prettier-ignore-end */
